import { Directive, ElementRef, Host, Injectable, Optional } from '@angular/core';
import { InvalidFormScrollDirective } from './invalid-form-scroll.directive';

/**
 * Exposes to dependency injection the element which is supposed to have the
 * scroll behavior of the current page.
 */
@Directive({
  selector: '[mfpScrollContainer]'
})
export class ScrollContainerDirective {

  readonly containerEl: HTMLElement = this.el.nativeElement;

  constructor(private el: ElementRef) { }

}
